import { Map } from 'immutable';
import { setOpenFiltersType, setAppliedFilterSummaryType } from './ResultsFiltersConstants';

export const initialState = Map({
  open: false,
  appliedFilterSummary: null,
});

// eslint-disable-next-line default-param-last
export default function resultsFiltersReducer(state = initialState, action) {
  if (action.type === setOpenFiltersType) {
    const { isOpen } = action.payload;

    return state.set('open', isOpen);
  }
  if (action.type === setAppliedFilterSummaryType) {
    return state.set('appliedFilterSummary', action.payload);
  }
  return state;
}
